import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Preloader from '../../../../general/Preloader';

const ModalIndex = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(false);
    const [message, setMessage] = useState({
        type: "",
        url: "",
        message: ""
    });

    const form = {
        user_id: props.user.id,
        discount_code_id: props.discount_code.id,
        affiliate_id: props.affiliate ? props.affiliate.id : "",
        price_id: props.price.id,
        reference: props.reference
    };

    const handleClick = () => {
        setIsLoaded(true)
        fetch(`/api/v1/create_order`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(form), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            if(data.type == "success"){
                setMessage(data)
                setIsLoaded(false)
            }else{
                setMessage(data)
                setIsLoaded(false)
            }
        });
    }

    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered" backdrop={props.backdrop}>
                <ModalBody>
                    <div className="row modal-wompi">
                        <div className="col-md-12 text-center mb-4">
                            <img src="https://statics.addi.com/logo/v2/main/addi-logo.svg" height={60} alt="" />
                        </div>

                        <div className="col-md-12 text-center mb-3">
                            <h4>Con la siguiente información procederemos con el pago. Por favor, revisa los datos y confirma que todo esté correcto antes de continuar.</h4>
                        </div>

                        <div className="col-md-12">
                            {!isLoaded ? (
                                <React.Fragment>
                                    {message.type == "" ? (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <strong className='label-user-info'>Nombre</strong>
                                                <p className='text-dark'>{props.user.name}</p>
                                            </div>

                                            <div className="col-md-4">
                                                <strong className='label-user-info'>Apellido</strong>
                                                <p className='text-dark'>{props.user.lastnames}</p>
                                            </div>

                                            <div className="col-md-4">
                                                <strong className='label-user-info'>Numero de telefono</strong>
                                                <p className='text-dark'>{props.user.phone}</p>
                                            </div>

                                            <div className="col-md-12">
                                                <hr />
                                            </div>

                                            <div className="col-md-6">
                                                <strong className='label-user-info'>Ciudad</strong>
                                                <p className='text-dark'>{props.user.city.name}</p>
                                            </div>

                                            <div className="col-md-6">
                                                <strong className='label-user-info'>Documento</strong>
                                                <p className='text-dark'>{props.user.document}</p>
                                            </div>

                                            <div className="col-md-12">
                                                <hr />
                                            </div>
                                            
                                            <div className="col-md-5">
                                                <strong className='label-user-info'>Correo</strong>
                                                <p className='text-dark'>{props.user.email}</p>
                                            </div>

                                            <div className="col-md-7">
                                                <strong className='label-user-info'>Direccion</strong>
                                                <p className='text-dark'>{props.user.address}</p>
                                            </div>

                                            <div className="col-md-12">
                                                <hr />
                                            </div>

                                            <div className="col-md-12 text-center">
                                                <button className='btn btn-primary text-white mr-2' onClick={() => handleClick()}>
                                                    <i className="fa fa-shopping-cart mr-2" aria-hidden="true"></i> Pagar
                                                </button>

                                                <button className='btn btn-danger text-white' onClick={() => props.toggle()}>
                                                    Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={`alert alert-${message.type} text-center text-dark`} role="alert">
                                            <h4>{message.message}</h4>
                                            <hr />
                                            {message.url && (
                                                <React.Fragment>
                                                    <a 
                                                        href={message.url} 
                                                        target='_blank'
                                                        className={`btn btn-addi mr-2`}
                                                    >
                                                        Continuar con la compra
                                                    </a>

                                                    <button className='btn btn-danger text-white' onClick={() => props.toggle()}>
                                                        Cerrar
                                                    </button>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : (
                                <div className="text-center">
                                    <Preloader/>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}


export default ModalIndex;

